<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">3</span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">4</span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">5</span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">6</span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="row"></div>
                        <div class="col-md-10 form-request-content-large">
                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                        name="exemption"
                                        method="post"
                                        enctype="multipart/form-data"
                                        novalidate="novalidate"
                                        class="needs-validation"
                                >
                                    <!-- Select -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks"
                                                for="eligible-parties"
                                        >Possibilité d'adhésion des ayants droit</label>
                                        <select id="eligible-parties"
                                                class="form-control select2"
                                                v-model="formData.isEligiblePartiesCanJoin"
                                                @change="handleEligiblePartiesJoinChange"
                                        >
                                            <option v-for="(option, index) in canJoinOptions"
                                                    :key="index"
                                                    :value="option.value"
                                            >{{ option.title }}</option>
                                        </select>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.isEligiblePartiesCanJoin.legalAdvice }}</p>
                                    </div>
                                    <!-- Select  -->

                                    <!-- Select  -->
                                    <div class="form-group" v-if="formData.isEligiblePartiesCanJoin">
                                        <label class="required-field-asterisks"
                                               for="eligible-parties-eligibility"
                                        >Adhésion des ayants droit à titre obligatoire ou facultatif</label>
                                        <select id="eligible-parties-eligibility"
                                                class="form-control select2"
                                                v-model="formData.eligiblePartiesJoinType"
                                                @change="handleEligiblePartiesJoinTypeChange"
                                        >
                                            <option v-for="(option, index) in joinTypeOptions"
                                                    :key="index"
                                                    :value="option.value"
                                            >{{ option.title }}</option>
                                        </select>
                                        <div v-if="legalInformation">
                                            <p class="input-legend">{{ legalInformation.eligiblePartiesJoinType.legalAdvice }}</p>
                                            <span class="invalid-feedback d-block">
                                            <span class="d-block">
                                                <span class="form-error-message ml-1"
                                                >{{ legalInformation.eligiblePartiesJoinType.attention }}</span>
                                            </span>
                                        </span>
                                        </div>
                                    </div>
                                    <!-- Select -->

                                    <!-- Select -->
                                    <div class="form-group" v-if="formData.isEligiblePartiesCanJoin">
                                        <label class="required-field-asterisks"
                                               for="membership-3"
                                        >Structure de cotisations</label>
                                        <select id="membership-3"
                                                class="form-control select2"
                                                v-model="formData.contributionOptionId"
                                                @change="handleContributionStructureChange"
                                        >
                                            <option v-for="contributionOption in filteredContributionOptions"
                                                    :key="contributionOption.id"
                                                    :value="contributionOption.id"
                                            >{{ contributionOption.title }}</option>
                                        </select>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.contributionOption.legalAdvice }}</p>
                                    </div>
                                    <!-- Select -->

                                    <!-- Contributions -->
                                    <div class="border-due" v-if="formData.contributions.length > 0">
                                        <h2>Cotisations</h2>
                                        <!-- Legal advices form particular cases -->
                                        <p v-if="Object.keys(this.due).length > 0
                                            && this.due.collectiveAgreement.codeIdcc === '1516'
                                            && legalInformation"
                                            class="input-legend contribution-legal-advice"
                                        >{{ legalInformation.contribution1516CollectiveAgreement.legalAdvice }}</p>
                                        <p v-if="Object.keys(this.due).length > 0
                                            && this.due.collectiveAgreement.codeIdcc === '176'
                                            && legalInformation"
                                            class="input-legend contribution-legal-advice"
                                        >{{ legalInformation.contribution176CollectiveAgreement.legalAdvice }}</p>
                                        <!-- Legal advices form particular cases -->
                                        <div v-for="(contribution, index) in formData.contributions" :key="index">
                                            <h3>{{ contribution.contributionOptionUnit.title | ucFirst }}</h3>
                                            <div class="form-group border-due-input">
                                                <label for="patronate">Part patronale</label>
                                                <input type="number"
                                                       id="patronate"
                                                       :class="{ 'is-invalid': $v.formData.contributions.$each[index].employerSharePercentage.$error }"
                                                       @input="
                                                            delayTouch($v.formData.contributions.$each[index].employerSharePercentage);
                                                            handleContributionEmployerPercentageChange(index)"
                                                       v-model.number="formData.contributions[index].employerSharePercentage"
                                                       class="form-control form-control-lg" placeholder="50%"
                                                >
                                                <FormError v-if="!$v.formData.contributions.$each[index].employerSharePercentage.validContribution
                                                                 && $v.formData.contributions.$each[index].employerSharePercentage.$dirty"
                                                           :error="`La part de cotisation à votre charge ne peut pas etre inférieure à
                                                                  ${ contribution.contributionMinimumPercentage.employerSharePercentage } %`"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.contributions.$each[index].employerSharePercentage.maxValue
                                                                 && $v.formData.contributions.$each[index].employerSharePercentage.$dirty"
                                                        error="Ce champ indique un pourcentage, veuillez saisir une valeur etre 0 et 100">
                                                </FormError>
                                                <p v-if="legalInformation"
                                                   class="input-legend"
                                                >{{ legalInformation.employerSharePercentage.legalAdvice }}</p>
                                                <label for="part-salariale">Part salariale</label>
                                                <input type="number"
                                                       id="part-salariale"
                                                       @input="
                                                            delayTouch($v.formData.contributions.$each[index].employeeSharePercentage);
                                                            handleContributionEmployeePercentageChange(index)"
                                                       v-model.number="formData.contributions[index].employeeSharePercentage"
                                                       class="form-control form-control-lg"
                                                       placeholder="50%"
                                                >
                                                <p v-if="legalInformation"
                                                   class="input-legend"
                                                >{{ legalInformation.employeeSharePercentage.legalAdvice }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Contributions -->

                                    <!-- Other affiliates contribution (176) -->
                                    <div v-if="Object.keys(this.due).length > 0 && this.due.collectiveAgreement.codeIdcc === '176'"
                                         class="form-group"
                                    >
                                        <label for="other-affiliates-contribution"
                                               class="required-field-asterisks"
                                        >Quelle part de la cotisation relative à ces « autres
                                            adhérents » souhaitez-vous prendre en charge ?</label>
                                        <input type="number"
                                               id="other-affiliates-contribution"
                                               class="form-control form-control-lg"
                                               placeholder="0%"
                                               :class="{ 'is-invalid': $v.formData.otherAffiliatesContribution.$error }"
                                               @input="delayTouch($v.formData.otherAffiliatesContribution)"
                                               v-model.number="formData.otherAffiliatesContribution"
                                        >
                                        <FormError v-if="$v.formData.otherAffiliatesContribution.$error"
                                                   error="Ce champ indique un pourcentage, veuillez saisir une valeur etre 0 et 100"
                                        ></FormError>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.otherAffiliatesContribution.legalAdvice }}</p>
                                        <ul>
                                            <li v-for="(option, index) in legalInformation.otherAffiliatesContributionOptions.legalAdvice"
                                                :key="index"
                                                class="input-legend"
                                            >
                                              {{ option }}
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- Other affiliates contribution (176) -->

                                    <!-- Is additional garanties mandatory -->
                                        <div class="form-group"
                                            v-if="Object.keys(this.due).length > 0 && this.due.collectiveAgreement.codeIdcc === '1404'"
                                        >
                                            <label class="required-field-asterisks"
                                                for="is-additional-guaranties-mandatory"
                                            >Souhaitez vous rendre obligatoire l'adhésion à des garanties
                                            complémentaires prévues au contrat </label>
                                            <select id="is-additional-guaranties-mandatory"
                                                    class="form-control select2"
                                                    v-model="formData.isAdditionalGuarantiesMandatory"
                                            >
                                                <option :value="true">Oui</option>
                                                <option :value="false">Non</option>
                                            </select>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.isAdditionalGuarantiesMandatory.legalAdvice }}</p>
                                        </div>
                                    <!-- Is additional garanties mandatory -->

                                    <!-- Contribution charged from salary -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks"
                                               for="contribution-charged-form-salary"
                                        >Souhaitez vous que les cotisations soient prélevées
                                            directement sur les salaires
                                            dus à vos salariés ? </label>
                                        <select id="contribution-charged-form-salary"
                                                class="form-control select2"
                                                v-model="formData.isContributionChargedFromSalary"
                                        >
                                            <option :value="true">Oui</option>
                                            <option :value="false">Non</option>
                                        </select>
                                        <div v-if="legalInformation">
                                            <p v-for="(legalAdvice, index) in legalInformation.isContributionChargedFromSalary.legalAdvice"
                                               :key="index"
                                               class="input-legend mt-2"
                                            >{{ legalAdvice }}</p>
                                        </div>
                                    </div>
                                    <!-- Contribution charged from salary -->

                                    <!-- Contribution charged days after due date -->
                                    <div class="form-group" v-if="formData.isContributionChargedFromSalary === false">
                                        <label class="required-field-asterisks"
                                               for="contribution-charged-days-after-due-date"
                                        >Les cotisations seront prélevées par l'assureur sur le compte
                                            bancaire du salarié dans les X jours suivant l'échéance
                                        </label>
                                        <input type="number"
                                               id="contribution-charged-days-after-due-date"
                                               :class="{ 'is-invalid': $v.formData.contributionChargedDaysAfterDebitDate.$error }"
                                               @input="delayTouch($v.formData.contributionChargedDaysAfterDebitDate)"
                                               v-model.number="formData.contributionChargedDaysAfterDebitDate"
                                               class="form-control form-control-lg"
                                        >
                                        <FormError v-if="$v.formData.contributionChargedDaysAfterDebitDate.$error"
                                                   error="Veuillez indiquer une quantité de jours"
                                        ></FormError>
                                        <p v-if="legalInformation"
                                           class="input-legend mt-2"
                                        >{{ legalInformation.contributionChargedDaysAfterDebitDate.legalAdvice }}</p>
                                    </div>
                                    <!-- Contribution charged days after due date -->

                                </form>
                            </div>
                        </div>

                        <div class="input-group col-md-10 mx-sm-auto my-md-4">
                            <div class="mx-sm-auto">
                                <button class="btn btn-lg btn-link btn__primary"
                                        :disabled="saveIsLoading || nextStepIsLoading"
                                        @click.prevent="toPreviousStep('due-second-step')"
                                >
                                    <span>Revenir à l'étape précédente</span>
                                </button>

                                <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                        :disabled="$v.$invalid || saveIsLoading || nextStepIsLoading"
                                        @click.prevent="saveDue()"
                                >
                                    <span>Enregistrer le brouillon</span>
                                    <ButtonSpinner :isLoading="saveIsLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>

                        <div class="input-group mx-sm-auto">
                            <div class="large-btn__box">
                                <button class="btn btn-success btn-lg btn-link btn__save--large"
                                        :disabled="$v.$invalid || saveIsLoading || nextStepIsLoading"
                                        @click.prevent="saveAndMoveForward('due-fourth-step')"
                                >
                                    <span>Enregistrer les modifications</span>
                                    <ButtonSpinner :isLoading="nextStepIsLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import FormError from '../../../components/FormError';
    import DueThirdStepManager from '../../../service/manager/due/thirdStepManager';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import Header from '../../../components/Header';
    import { mapActions, mapGetters } from 'vuex';
    import { validContributionConstraint } from '../../../utils/validation';
    import { required, minValue, maxValue } from 'vuelidate/lib/validators';
    import { ucFirst } from '../../../utils/filters';
    import {
        fetchAllContributionOptionUnits,
        fetchContributionOptionsByCollectiveAgreementId,
        fetchEmployeeSharedPercentage
    } from '../../../service/api/dues.api';

    export default {
        mixins: [ValidationDelayTouch, DueStepsNavigation],
        data() {
            return {
                isEligiblePartiesCanJoinOptions: [
                    { title: 'Oui', value: true, available: true },
                    { title: 'Non', value: false, available: true }
                ],
                eligiblePartiesJoinTypeOptions: [
                    { title: 'Obligatoire', value: 'mandatory', available: true },
                    { title: 'Facultative', value: 'optional', available: true }
                ],
                mandatoryContributionOptionsIds: [3, 4, 6, 7],
                optionalContributionOptionsIds: [2, 5],
                contributionOptionUnits: [],
                contributionOptions: [],
                filteredContributionOptions: [],
                formData: {
                    isEligiblePartiesCanJoin: null,
                    eligiblePartiesJoinType: null,
                    contributionOptionId: null,
                    contributions: [],
                    otherAffiliatesContribution: null,
                    isAdditionalGuarantiesMandatory: null,
                    isContributionChargedFromSalary: null,
                    contributionChargedDaysAfterDebitDate: null
                },
                saveIsLoading: false,
                nextStepIsLoading: false
            };
        },
        computed: {
            ...mapGetters({
                currentStep: 'currentStep',
                due: 'due',
                legalInformation: 'legalInformation'
            }),
            canJoinOptions() {
                return this.isEligiblePartiesCanJoinOptions.filter((option) => {
                    return option.available === true;
                })
            },
            joinTypeOptions() {
                return this.eligiblePartiesJoinTypeOptions.filter((option) => {
                    return option.available === true;
                })
            }
        },
        async mounted() {
            await this.fetchDue();
            await this.fetchDueLegalInformation();
            await this.fetchContributionOptions();
            await this.fetchContributionOptionUnits();
            await this.setCurrentStep(3);
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'setCurrentStep',
                fetchCurrentDue: 'fetchCurrentDue',
                updateCurrentDue: 'updateCurrentDue',
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async fetchDue() {
                await this.fetchCurrentDue(this.$route.params.id);
                await this.processCollectiveAgreementDependentFields();
                this.formData = {
                    ...this.formData,
                    ... await DueThirdStepManager.createFormDataForThirdStepFromResponse(this.due)
                };
            },
            async fetchContributionOptionUnits() {
                const { data } = await fetchAllContributionOptionUnits();
                this.contributionOptionUnits = data;
            },
            async fetchContributionOptions() {
                const { data } = await fetchContributionOptionsByCollectiveAgreementId(this.due.collectiveAgreement.id);
                this.contributionOptions = data;

                if (!this.formData.contributionOptionId) {
                    this.filteredContributionOptions = data;
                    return;
                }

                if (this.formData.contributionOptionId) {
                    if (this.mandatoryContributionOptionsIds.includes(this.formData.contributionOptionId)) {
                        this.filteredContributionOptions = this.handleMandatoryContributionOptionsFilter();
                    }

                    if (this.optionalContributionOptionsIds.includes(this.formData.contributionOptionId)) {
                        this.filteredContributionOptions = this.handleOptionalContributionOptionsFilter();
                    }
                }
            },
            async handleEligiblePartiesJoinChange() {
                this.formData.contributions = [];
                if (false === this.formData.isEligiblePartiesCanJoin) {
                    await this.addContributionDynamicField(this.contributionOptionUnits.find(option => {
                        return option.code === 'SC1';
                    }));
                    const firstContributionOption = this.contributionOptions.find((option) => {
                        return option.code === 1;
                    });
                    this.formData.contributionOptionId = firstContributionOption.id;
                } else {
                    this.formData.contributionOptionId = null;
                }
            },
            async handleContributionStructureChange() {
                this.formData.contributions = [];
                const contributionOption = this.contributionOptions.find(option => {
                    return option.id === this.formData.contributionOptionId;
                });
                for (const contributionOptionUnit of contributionOption.units) {
                    await this.addContributionDynamicField(contributionOptionUnit);
                }
            },
            async addContributionDynamicField(contributionOptionUnit) {
                const { data } = await fetchEmployeeSharedPercentage(
                    contributionOptionUnit.id,
                    this.due.collectiveAgreement.id
                );

                const employerSharePercentageValue = data ? data.employerSharePercentage : 0;
                const employeeSharePercentageValue = 100 - employerSharePercentageValue;
                this.formData.contributions.push({
                    contributionMinimumPercentage: data,
                    contributionOptionUnit: contributionOptionUnit,
                    employerSharePercentage: employerSharePercentageValue,
                    employeeSharePercentage: employeeSharePercentageValue
                });
            },
            handleContributionEmployerPercentageChange(contributionIndex) {
                this.formData.contributions[contributionIndex].employeeSharePercentage =
                    100 - this.formData.contributions[contributionIndex].employerSharePercentage;
            },
            handleContributionEmployeePercentageChange(contributionIndex) {
                this.formData.contributions[contributionIndex].employerSharePercentage =
                    100 - this.formData.contributions[contributionIndex].employeeSharePercentage;
                this.$v.formData.contributions.$each[contributionIndex].employerSharePercentage.$touch();
            },
            handleEligiblePartiesJoinTypeChange(e) {
                switch (e.target.value) {
                    case 'mandatory':
                        this.filteredContributionOptions = this.handleMandatoryContributionOptionsFilter();
                        break;
                    case 'optional':
                        this.filteredContributionOptions = this.handleOptionalContributionOptionsFilter();
                        break;
                    default:
                        this.filteredContributionOptions = this.contributionOptions;
                        break;
                }
            },
            handleMandatoryContributionOptionsFilter() {
                return this.contributionOptions.filter((option) => {
                    return this.mandatoryContributionOptionsIds.includes(option.id)
                });
            },
            handleOptionalContributionOptionsFilter() {
                return this.contributionOptions.filter((option) => {
                    return this.optionalContributionOptionsIds.includes(option.id)
                });
            },
            async prepareRequest() {
                return await DueThirdStepManager.createThirdStepUpdateRequest(this.formData);
            },
            async processCollectiveAgreementDependentFields() {
                const collectiveAgreement = this.due.collectiveAgreement;

                if (collectiveAgreement.eligiblePartiesJoinRequired) {
                    this.formData.isEligiblePartiesCanJoin = true;
                    this.isEligiblePartiesCanJoinOptions[1].available = false;
                }
                this.eligiblePartiesJoinTypeOptions[0].available = collectiveAgreement.isEligiblePartiesJoinMandatory;
                this.eligiblePartiesJoinTypeOptions[1].available = collectiveAgreement.isEligiblePartiesJoinOptional;
            }
        },
        validations() {
            let validations = {
                formData: {
                    isEligiblePartiesCanJoin: {
                        required
                    },
                    contributions: {
                        $each: {
                            employerSharePercentage: {
                                validContribution: validContributionConstraint,
                                maxValue: maxValue(100)
                            },
                            employeeSharePercentage: {
                                required,
                            }
                        }
                    },
                    isContributionChargedFromSalary: {
                        required
                    }
                }
            };

            if (this.formData.isEligiblePartiesCanJoin) {
                validations.formData.eligiblePartiesJoinType = {
                    required
                };
                validations.formData.contributionOptionId = {
                    required
                };
            }

            if (Object.keys(this.due).length > 0 && this.due.collectiveAgreement.codeIdcc === '1404') {
                 validations.formData.isAdditionalGuarantiesMandatory = {
                    required
                };
            }

            if (Object.keys(this.due).length > 0 && this.due.collectiveAgreement.codeIdcc === '176') {
                validations.formData.otherAffiliatesContribution = {
                    minValue: minValue(0),
                    maxValue: maxValue(100),
                    required
                };
            }

            if (this.formData.isContributionChargedFromSalary === false) {
                validations.formData.contributionChargedDaysAfterDebitDate = {
                    required
                };
            }

            return validations;
        },
        filters: {
            ucFirst
        },
        components: {
            Header,
            Sidebar,
            Footer,
            FormError,
            ButtonSpinner
        }
    }
</script>
